var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { GGOBaseComponent } from '../ggo.base.component.js';
import { ButtonComponent } from '../button/button.component.js';
import { Translate } from '../../utils/translate.js';
let SectionComponent = class SectionComponent extends GGOBaseComponent {
    static { this.properties = {
        title: { type: String },
        action: { type: String },
        rename: { type: Function },
        object: { type: Object },
    }; }
    static get styles() {
        return [
            ...super.styles,
            css `
        .ggo-card {
          margin-top: 1rem;
          background: #f8f9fa;
        }
      `,
        ];
    }
    constructor() {
        super();
        this.title = '';
        this.action = '';
        this.object = null;
        //this.rename = (event: CustomEvent) => {};
    }
    handleNewAction(action) {
        const eventData = { action };
        if (this.id)
            eventData['id'] = this.id;
        if (this.object)
            eventData['object'] = this.object;
        this.dispatchEvent(new CustomEvent('action', { detail: eventData }));
    }
    handleRename(event) {
        console.log('rename', event);
        this.rename.call(this, event);
    }
    render() {
        return html `<article class="slds-card ggo-card">
      <div class="slds-card__header slds-grid">
        <header class="slds-media slds-media_center slds-has-flexi-truncate">
          <div class="slds-media__body">
            <h2 class="slds-card__header-title">
                ${this.getTitle()}
            </h2>
          </div>
          <div class="slds-no-flex">
            ${this.getButtons()}
          </div>
        </header>
      </div>
      <div class="slds-card__body slds-card__body_inner"><slot></div>
    </article>`;
    }
    getTitle() {
        if (this.rename) {
            return html `<ggo-editable-label label="${this.title}" .object="${this.object}" @changed=${this.handleRename}></ggo-editable-label>`;
        }
        else {
            return html `<span>${this.title}</span>`;
        }
    }
    getButtons() {
        if (this.action.length === 0) {
            return nothing;
        }
        const buttons = this.action.split(',').map((action) => action.trim());
        return html `
      ${buttons.map((button) => {
            switch (button) {
                case 'add':
                    return html `<ggo-button variant="${ButtonComponent.ACTION}" @click=${(event) => this.handleNewAction(button)}
              >${Translate.get('btn_add')}</ggo-button
            >`;
                case 'delete':
                    return html `<ggo-button variant="${ButtonComponent.ACTION}" @click=${(event) => this.handleNewAction(button)}
              >${Translate.get('btn_delete')}</ggo-button
            >`;
                default:
                    return html `<button class="slds-button slds-button_neutral" @click=${(event) => this.handleNewAction(button)}>${button}</button>`;
            }
        })}
    `;
    }
};
SectionComponent = __decorate([
    customElement('ggo-section')
], SectionComponent);
export { SectionComponent };
